import React from 'react';

export const ClickAndCollectListContext = React.createContext({
    shipments: [],
    selectedShipment: null,
    setSelectedShipment: (shipment) => {},
    zones: [],
    selectedZone: null,
    setSelectedZone: (zone) => {},
    searchString: '',
    setSearchString: (searchString) => {},
    selectedContainer: null,
    setSelectedContainer: (container) => {},
    onPageChange: (page) => {},
    getShipments: (link) => {},
    refreshShipments: () => {},
    nextLink: null,
    previousLink: null,
    totalPages: 0,
    sort: {
        orderBy: 'date',
        orderDirection: 'asc',
    },
    setSort: (sort) => {},
    openToast: () => {},
    handleRequestSort: (property) => {},
})
